var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "transition",
    { attrs: { name: "fade", appear: "" } },
    [
      _c(
        "v-expansion-panels",
        {
          class: [
            "totals-container",
            _vm.breakpointClass,
            _vm.disableExpansionPanel,
          ],
          attrs: { flat: "" },
        },
        [
          _c(
            "v-expansion-panel",
            [
              _c(
                "v-expansion-panel-header",
                _vm._l(_vm.header, function (item, index) {
                  return _c("TotalItemComponent", {
                    key: `header-item-${index}`,
                    attrs: { item: item, fieldTotalName: _vm.fieldTotalName },
                  })
                }),
                1
              ),
              _c(
                "v-expansion-panel-content",
                _vm._l(_vm.content, function (item, index) {
                  return _c("TotalItemComponent", {
                    key: `content-item-${index}`,
                    attrs: { item: item, fieldTotalName: _vm.fieldTotalName },
                  })
                }),
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }